// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import fileQuestion01Icon from "@/assets/icons/file-question-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FileQuestion01IconProps = Omit<IconProps, "name">;

export function FileQuestion01Icon(props: FileQuestion01IconProps): React.ReactNode {
  return <Icon name={fileQuestion01Icon} {...props} />;
}
